import { GraphicElement } from './GraphicElement';
import { Position } from '../Transform/Position';
import { Size } from '../Size';
import { Scale } from '../Transform/Scale';
import { Rotation } from '../Transform/Rotation';
import { Image } from './Image';
import { Media } from '../Media';
export class ImageSVG extends Image {
    constructor(
        engine,
        content,
        position = new Position(),
        uuid = GraphicElement.generateUUID(),
        size = new Size(),
        options = {},
        scale = new Scale(),
        rotation = new Rotation()
    ) {
        super(engine, content, position, uuid, size, options, scale, rotation);
        this.type = 'ImageSVG';
        this.canBeUnlocked = true;
    }
    static hydrate(data) {
        const imageSvg = new ImageSVG(
            data._engine,
            data._content,
            new Position(),
            data._uuid,
            new Size(data.originSize._width, data.originSize._height),
            data.options
        );
        imageSvg.content = Media.fromAdress(data._content._mediaAddress);
        imageSvg.originalContent = Media.fromAdress(data.originalContent._mediaAddress);
        imageSvg.transform.resize(new Scale(data.transform._scale._scaleX, data.transform._scale._scaleY));
        imageSvg.transform.rotate(data.transform._rotation._angle);
        imageSvg.isInsideTheme = data._isInsideTheme;
        imageSvg.transform.groupId = data.transform.groupId;
        if (data.transform._localPos) {
            imageSvg.transform.localPos = new Position(data.transform._localPos._x, data.transform._localPos._y);
        } else {
            imageSvg.transform.moveTo(new Position(data.transform._pos._x, data.transform._pos._y));
        }
        imageSvg.visible = data.visible;
        return imageSvg;
    }
}
